const neededFormat = {
    day: 86400,
    hour: 3600,
    minute: 60,
    second: 1,
};

export const getDateDifference = (laterDate) => {
    const result = {};
    let difference = Math.abs(new Date(laterDate) - new Date()) / 1000;
    Object.keys(neededFormat).forEach((key) => {
        result[key] = Math.floor(difference / neededFormat[key]);
        difference -= result[key] * neededFormat[key];
    });
    return result;
};
